import { PaginatedResponse } from '../types/pagination'

import { http } from '@/app/lib/http/client'

export interface ProductBatch {
  id: number
  batch_number: string
  expiration_date: string
  quantity?: number
  archived_at?: string | null
  active_reserved_quantity?: number
  is_expired?: boolean
  can_archive?: boolean
  archive_blocking_reason?: string | null
  can_retire_expired?: boolean
  retire_blocking_reason?: string | null
  sucursal?: {
    id: number
    name: string
  }
  created_at?: string
  updated_at?: string
}

export interface StoreProductBatchPayload {
  sucursal_id: number
  batch_number: string
  expiration_date: string
}

export interface UpdateProductBatchPayload {
  batch_number?: string
  expiration_date?: string
  reason: string
}

export interface RetireExpiredProductBatchPayload {
  expected_quantity: number
  reason: string
}

export const batchService = {
  async getBatches(productId: number, page: number = 1, params?: { status?: string, from?: string, to?: string, sucursal_id?: number, per_page?: number }): Promise<PaginatedResponse<ProductBatch>> {
    const response = await http.get(`/products/${productId}/batches`, { params: { page, ...params } })
    const d = response.data
    if (d?.data?.data && Array.isArray(d.data.data)) return d.data
    if (d?.data && Array.isArray(d.data)) return d
    return d
  },

  async createBatch(productId: number, payload: StoreProductBatchPayload): Promise<ProductBatch> {
    const response = await http.post(`/products/${productId}/batches`, payload)
    const d = response.data
    return d?.data ?? d
  },

  async updateBatch(productId: number, batchId: number, payload: UpdateProductBatchPayload): Promise<ProductBatch> {
    const response = await http.put(`/products/${productId}/batches/${batchId}`, payload)
    const d = response.data
    return d?.data ?? d
  },

  async deleteBatch(productId: number, batchId: number): Promise<void> {
    const response = await http.delete(`/products/${productId}/batches/${batchId}`)
    const d = response.data
    return d?.data ?? d
  },

  async retireExpiredBatch(productId: number, batchId: number, payload: RetireExpiredProductBatchPayload): Promise<void> {
    const response = await http.post(`/products/${productId}/batches/${batchId}/retire-expired`, payload)
    const d = response.data
    return d?.data ?? d
  },
}
